module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Disagreeing Virtuously: Religious Conflict in Interdisciplinary Perspective")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('i', [_vm._v("Acad.")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Augustine, "), _c('i', [_vm._v("Contra Academicos")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Catech.")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Augustine, "), _c('i', [_vm._v("De catechizandis rudibus")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Civ.")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Augustine, "), _c('i', [_vm._v("De civitate Dei")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Doctr. chr.")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Augustine, "), _c('i', [_vm._v("De doctrina Christiana")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Enchir.")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Augustine, "), _c('i', [_vm._v("Enchiridion")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Ep.")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Epistulae")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KRS")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("G. S. Kirk, J. E. Raven, and M. Schofield, "), _c('i', [_vm._v("The Presocratic Philosophers: A Critical History with a Selection of Texts")]), _vm._v(". 2nd ed. Cambridge: Cambridge University Press, 1983 (numbers refer to fragments)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("PA")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("St. Thomas Aquinas, "), _c('i', [_vm._v("Sententia super Posteriora Analytica")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ST")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("St. Thomas Aquinas, "), _c('i', [_vm._v("Summa Theologiae")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("WA")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("D. Martin Luthers Werke")]), _vm._v(" [Weimarer Ausgabe]. Weimar: Böhlau, 1883–1993")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847bb512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 75
// module chunks = 0